import { render, staticRenderFns } from "./ProjectDetailsOverlay.vue?vue&type=template&id=00e9ba37&scoped=true"
import script from "./ProjectDetailsOverlay.vue?vue&type=script&lang=ts"
export * from "./ProjectDetailsOverlay.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDetailsOverlay.vue?vue&type=style&index=0&id=00e9ba37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e9ba37",
  null
  
)

export default component.exports